import React, { Fragment, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/Navbar/Navbar";
import CareerSection from "../../components/CareerSection/CareerSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import TerminModal from "../../components/TerminModal/TerminModal";

const CareerDetailPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [terminModalOpen, setTerminModalOpen] = useState(false);

  const openTerminModal = () => {
    setTerminModalOpen(true);
  };

  const closeTerminModal = () => {
    setTerminModalOpen(false);
  };

  return (
    <Fragment>
      <Navbar openTerminModal={openTerminModal} />
      <main className="page-offset career-page" aria-label={t("Career")}>
        <CareerSection jobId={id} />
      </main>
      <Footer />
      <Scrollbar openTerminModal={openTerminModal} />
      <TerminModal open={terminModalOpen} onCloseModal={closeTerminModal} />
    </Fragment>
  );
};

export default CareerDetailPage;
